module.exports = __webpack_public_path__ + "static/staff-john-1-09e93994f1a558c25bbc439c0ec455cc.png";